//Product page quantity change
$( document ).ready(function() {
  var tagLookup = w3ProductData.tags;
  var accessoryProductTags = tagLookup;
  var accessoryQtyTag;
  var accessoryQtyAmount;
  $.each( accessoryProductTags, function( index, tag ){
    if(tag.indexOf("Qty-") != -1){
      accessoryQtyTag = index; 
    }
  });         
  if (accessoryProductTags[accessoryQtyTag] != null){
    var accessoryQtyAmount = parseFloat(accessoryProductTags[accessoryQtyTag].replace('Qty-', ''));
    console.log(accessoryQtyAmount);
    //Update Quantity
    $("#quantity").val(accessoryQtyAmount);
  }
});
//On product with accessory, acceessory quantity change
function accessoryItemAddedCallback(div, product) { 
  var accessoryProductTags = product.tags;
  var accessoryQtyTag;
  var accessoryQtyAmount;
  var accessoryVendor = product.vendor;
  var accessoryVendorString = accessoryVendor.replace(/[^a-z0-9\s]/gi, '-').replace(/[_\s]/g, '-').toLowerCase();
  var vendorLink = 'https://www.urotuning.com/' + accessoryVendorString;
  var vendorImg = 'https://urotuned.com/mfg_img/' + accessoryVendorString + '.jpg';
  var fullVendorItem = '<a class="acc-vendor" target="_blank" href="' + vendorLink + '"><img onerror="$(this).hide();" src="' + vendorImg + '"></a>';
  $($(div).find('.accessory-price').first().next().andSelf()).wrapAll('<div class="acc-price-wrap"/>');
  $(fullVendorItem).insertAfter(div.find('.acc-price-wrap'));
  $($(div).find('.acc-price-wrap').next().andSelf()).wrapAll('<div class="price-vendor-wrap"/>');

  $.each( accessoryProductTags, function( index, tag ){
    if(tag.indexOf("Qty-") != -1){
      accessoryQtyTag = index; 
    }
  });         
  if (accessoryProductTags[accessoryQtyTag] != null){
    var accessoryQtyAmount = parseFloat(accessoryProductTags[accessoryQtyTag].replace('Qty-', ''));
  }else{
    accessoryQtyAmount = 1;
  }
  //Update Quantity
  $(div).find(".accessoryQuantity").val(accessoryQtyAmount);
}
//On product with accessory, quick view modal acceessory quantity change
function accessoriesQuickViewCallback(divModal, product){
  var accessoryProductTags = product.tags;
  var accessoryQtyTag;
  var accessoryQtyAmount;
  $.each( accessoryProductTags, function( index, tag ){
    if(tag.indexOf("Qty-") != -1){
      accessoryQtyTag = index; 
    }
  });         
  if (accessoryProductTags[accessoryQtyTag] != null){
    var accessoryQtyAmount = parseFloat(accessoryProductTags[accessoryQtyTag].replace('Qty-', ''));
  }
  else{
    accessoryQtyAmount = 1;
  }
  //Update Quantity
  $(divModal).find(".accessories-quantity").val(accessoryQtyAmount);
};   